import { RiderColor } from '@polaris-customerweb/sharedcomponents.core';
import {
    Geofence,
    PlannedRide,
    TrackedRide,
    Waypoint,
} from '@polaris-customerweb/sharedcomponents.user-content';
import { Collection } from './collection';

export class GeoFileUploadCollectionCheckbox {
    feature: PlannedRide | TrackedRide | Geofence | Waypoint;
    checked = true;
    editing = false;
    editingColor = false;
    hoveredOnMap = false;
    icon: string;
    itemLength?: number;
    itemDuration?: number;
    itemSize?: number;

    constructor(feature: PlannedRide | TrackedRide | Geofence | Waypoint) {
        this.feature = feature;
    }

    get color() {
        return this.feature instanceof Collection
            ? undefined
            : (this.feature.color as RiderColor);
    }
}
